import { ArrowRight, Mail } from 'lucide-react';
import { EMAIL, useLanguage } from '../i18n/content';
import { FadeUp } from './Reveal';

export function Contact() {
  const { t } = useLanguage();

  return (
    <section id="kontak" className="relative py-16 lg:py-20">
      <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-10">
        <FadeUp>
          <div
            data-testid="contact-panel"
            className="relative overflow-hidden rounded-3xl bg-[#0E0E12] px-6 py-8 sm:px-8 lg:px-12 lg:py-10"
          >
            <div
              aria-hidden
              className="pointer-events-none absolute -left-24 -top-24 h-80 w-80 rounded-full bg-[radial-gradient(circle,rgba(229,9,20,0.26),transparent_65%)] blur-2xl"
            />
            <div
              aria-hidden
              className="halftone pointer-events-none absolute -right-4 -top-4 h-44 w-44 opacity-60 [mask-image:linear-gradient(225deg,black,transparent_70%)]"
            />

            <div className="relative grid items-center gap-8 lg:grid-cols-[1.1fr_1fr] lg:gap-12">
              <h2
                className="font-display text-3xl font-extrabold tracking-tight text-white sm:text-4xl"
                data-testid="contact-title"
              >
                {t.contact.titleA}
                <span className="block">
                  {t.contact.titleB}
                  <span className="text-nofina-red">.</span>
                </span>
              </h2>

              <div>
                <p className="text-base leading-relaxed text-slate-400">
                  {t.contact.text}
                </p>
                <a
                  href={`mailto:${EMAIL}`}
                  data-testid="contact-cta-button"
                  className="group mt-6 inline-flex w-full items-center gap-4 rounded-2xl border border-nofina-red/40 bg-nofina-red/10 px-5 py-4 transition-all duration-300 hover:border-nofina-red hover:bg-nofina-red/20 hover:shadow-[0_0_36px_rgba(229,9,20,0.3)] sm:w-auto sm:min-w-[320px]"
                >
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-nofina-red text-white transition-shadow duration-300 group-hover:shadow-[0_0_20px_rgba(229,9,20,0.5)]">
                    <Mail className="h-5 w-5" />
                  </span>
                  <span className="flex flex-col text-left">
                    <span className="text-sm font-semibold text-white">
                      {t.contact.cta}
                    </span>
                    <span className="text-xs text-slate-400 sm:text-sm">
                      {EMAIL}
                    </span>
                  </span>
                  <ArrowRight className="ml-auto h-4 w-4 text-nofina-red transition-transform duration-300 group-hover:translate-x-1" />
                </a>
              </div>
            </div>
          </div>
        </FadeUp>
      </div>
    </section>
  );
}
